// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body,
html {
  margin: 0;
  padding: 0;
  /* height: 100%; */
  font-family: 'Inter', sans-serif;
  

}

.App {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #ECEFFF;
}

.container {
  max-width: 1200px;
  width: 100%;
  background-color: #fff;
  border-radius: 16px;

}

.row {
  display: flex;
  flex-wrap: wrap;
  /* width: 100%; */
  overflow-x: hidden;

}

.image-container {

  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-container img {
  width: 500px;
  height: 500px;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}

.form-container {
  padding: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 500px;
  height: auto;
}

h2 {
  text-align: center;
  margin-bottom: 20px;
  color: #232323;
  /* width: 480px; */
  font-size: 24px;
  font-weight: 700;
  line-height: 40.05px;
  font-family: 'Inter', sans-serif;

  

}

.form-inputt {
  height: 456px;

}

.form-group {
  margin-bottom: 15px;
  width: 50%;
  /* width: auto; */
}



.form-group label {
  margin-bottom: 2px;
  font-size: 16px;
  font-weight: 500;
  color: #232323;
  font-family: 'Inter', sans-serif;

}

.form-group input {
  width: 100%;
  padding: 12px 10px 12px 10px;
  border: 1px solid #D0D0D0;
  border-radius: 8px;
  font-size: 16px;
  height: 41px;

}

.form-group textarea {
  width: 100%;
  height: 80px;
  border-radius: 8px;
  border: 1px solid #D0D0D0;
  padding: 12px 10px 12px 10px;
}

.submit-btn {
  width: 100%;
  height: 43px;
  padding: 12px 10px 12px 10px;
  background-color: #506CFE;
  border: none;
  border-radius: 8px;
  color: #FFFFFF;
  font-size: 16px;
  font-weight: 700;
  line-height: 19.36px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  font-family: 'Inter', sans-serif;

}



.password-container {
  display: flex;
  align-items: center;
}

.password-container input {
  flex: 1 1;
}

.password-toggle-btn-registration{
  position: absolute;
  right: 2.5%;
  font-size: 13px;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  background: none;
  cursor: pointer;
  color: #000000;
}

.password-toggle-btn-registration1{
  position: absolute;
  right: 2.5%;
  font-size: 13px;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  background: none;
  cursor: pointer;
  color: #000000;
}

::placeholder {
  color: #808080;
  font-weight: 400;
  font-size: 14px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .image-container {
    display: none;
  }

  .form-container {
    width: 98%;
    margin: 30px 5px;
    
  }
  .submit-btn{
    margin-top: 10px;
  }
}
@media (min-width: 20px) and (max-width: 426px) {
  
  .form-container {
    width: 100%;
  }
  .row {
    display: flex;
    flex-direction: column;
    /* margin-right: 0px; */
    padding-right: 4px;
  }
  
  .form-group {
    width: 100%;
  }
  .form-group textarea {
    width: 100%;
  }
  .submit-btn{
    margin-bottom: 20px;
  }
  .form-group label{
    margin: 0px;
    font-size: 15px;
  }
}

.already-registered {
  margin-top: 10px;
  text-align: center;
}

.already-registered .login-link {
  color: #3399cc;
  text-decoration: none;
}

.already-registered .login-link:hover {
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/components/Registration/ragistration.css"],"names":[],"mappings":"AAAA;;EAEE,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,gCAAgC;;;AAGlC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;;AAErB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,kBAAkB;;AAEpB;;AAEA;;EAEE,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gCAAgC;;;;AAIlC;;AAEA;EACE,aAAa;;AAEf;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,iBAAiB;AACnB;;;;AAIA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gCAAgC;;AAElC;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,YAAY;;AAEd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,sCAAsC;EACtC,gCAAgC;;AAElC;;;;AAIA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,UAAU;IACV,gBAAgB;;EAElB;EACA;IACE,gBAAgB;EAClB;AACF;AACA;;EAEE;IACE,WAAW;EACb;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":["body,\nhtml {\n  margin: 0;\n  padding: 0;\n  /* height: 100%; */\n  font-family: 'Inter', sans-serif;\n  \n\n}\n\n.App {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background-color: #ECEFFF;\n}\n\n.container {\n  max-width: 1200px;\n  width: 100%;\n  background-color: #fff;\n  border-radius: 16px;\n\n}\n\n.row {\n  display: flex;\n  flex-wrap: wrap;\n  /* width: 100%; */\n  overflow-x: hidden;\n\n}\n\n.image-container {\n\n  padding: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.image-container img {\n  width: 500px;\n  height: 500px;\n  border-top-left-radius: 8px;\n  border-bottom-left-radius: 8px;\n}\n\n.form-container {\n  padding: 30px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  width: 500px;\n  height: auto;\n}\n\nh2 {\n  text-align: center;\n  margin-bottom: 20px;\n  color: #232323;\n  /* width: 480px; */\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 40.05px;\n  font-family: 'Inter', sans-serif;\n\n  \n\n}\n\n.form-inputt {\n  height: 456px;\n\n}\n\n.form-group {\n  margin-bottom: 15px;\n  width: 50%;\n  /* width: auto; */\n}\n\n\n\n.form-group label {\n  margin-bottom: 2px;\n  font-size: 16px;\n  font-weight: 500;\n  color: #232323;\n  font-family: 'Inter', sans-serif;\n\n}\n\n.form-group input {\n  width: 100%;\n  padding: 12px 10px 12px 10px;\n  border: 1px solid #D0D0D0;\n  border-radius: 8px;\n  font-size: 16px;\n  height: 41px;\n\n}\n\n.form-group textarea {\n  width: 100%;\n  height: 80px;\n  border-radius: 8px;\n  border: 1px solid #D0D0D0;\n  padding: 12px 10px 12px 10px;\n}\n\n.submit-btn {\n  width: 100%;\n  height: 43px;\n  padding: 12px 10px 12px 10px;\n  background-color: #506CFE;\n  border: none;\n  border-radius: 8px;\n  color: #FFFFFF;\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 19.36px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  font-family: 'Inter', sans-serif;\n\n}\n\n\n\n.password-container {\n  display: flex;\n  align-items: center;\n}\n\n.password-container input {\n  flex: 1;\n}\n\n.password-toggle-btn-registration{\n  position: absolute;\n  right: 2.5%;\n  font-size: 13px;\n  top: 50%;\n  transform: translateY(-50%);\n  border: none;\n  background: none;\n  cursor: pointer;\n  color: #000000;\n}\n\n.password-toggle-btn-registration1{\n  position: absolute;\n  right: 2.5%;\n  font-size: 13px;\n  top: 50%;\n  transform: translateY(-50%);\n  border: none;\n  background: none;\n  cursor: pointer;\n  color: #000000;\n}\n\n::placeholder {\n  color: #808080;\n  font-weight: 400;\n  font-size: 14px;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .image-container {\n    display: none;\n  }\n\n  .form-container {\n    width: 98%;\n    margin: 30px 5px;\n    \n  }\n  .submit-btn{\n    margin-top: 10px;\n  }\n}\n@media (min-width: 20px) and (max-width: 426px) {\n  \n  .form-container {\n    width: 100%;\n  }\n  .row {\n    display: flex;\n    flex-direction: column;\n    /* margin-right: 0px; */\n    padding-right: 4px;\n  }\n  \n  .form-group {\n    width: 100%;\n  }\n  .form-group textarea {\n    width: 100%;\n  }\n  .submit-btn{\n    margin-bottom: 20px;\n  }\n  .form-group label{\n    margin: 0px;\n    font-size: 15px;\n  }\n}\n\n.already-registered {\n  margin-top: 10px;\n  text-align: center;\n}\n\n.already-registered .login-link {\n  color: #3399cc;\n  text-decoration: none;\n}\n\n.already-registered .login-link:hover {\n  text-decoration: underline;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
